import {
  booleanAttribute,
  DestroyRef,
  Directive,
  effect,
  inject,
  input,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[appShowIfLoggedIn]',
  standalone: true,
})
export class ShowIfLoggedInDirective {
  readonly #destroyRef = inject(DestroyRef);
  readonly #authService = inject(AuthService);
  readonly #templateRef = inject(TemplateRef);
  readonly #viewContainer = inject(ViewContainerRef);
  /**
   * Ha belepett user eseten mutassuk az elemet akkor true, ha elrejsuk akkor false
   *
   * default: true
   */
  readonly appShowIfLoggedIn = input(true, { transform: booleanAttribute });
  // Signal alapú állapotkezelés
  #isLoggedIn = false;

  constructor() {
    this.#authService.isAuthenticated$
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(loggedIn => {
        this.#isLoggedIn = loggedIn;
        this.#updateView();
      });

    effect(() => {
      this.appShowIfLoggedIn();
      this.#updateView();
    });
  }

  #updateView(): void {
    this.#viewContainer.clear();

    if (this.#isLoggedIn === this.appShowIfLoggedIn()) {
      // Elem megjelenítése
      if (this.#viewContainer.length === 0) {
        this.#viewContainer.createEmbeddedView(this.#templateRef);
      }
    }
  }
}
